module.exports = __webpack_public_path__ + "media/images/flags/1x1/are-65460aa9964c76f2ad8d04dc15906da4.svg";